var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4623 0.808262C11.4244 0.716892 11.3604 0.63879 11.2782 0.583833C11.1959 0.528876 11.0993 0.499532 11.0004 0.499512H1.00039C0.901446 0.499434 0.8047 0.528716 0.722403 0.583652C0.640106 0.638587 0.575959 0.716705 0.538082 0.808117C0.500206 0.899528 0.490304 1.00012 0.509629 1.09717C0.528954 1.19421 0.576638 1.28333 0.646644 1.35326L5.64664 6.35326C5.69308 6.39975 5.74823 6.43663 5.80892 6.46179C5.86962 6.48695 5.93469 6.4999 6.00039 6.4999C6.0661 6.4999 6.13117 6.48695 6.19186 6.46179C6.25256 6.43663 6.30771 6.39975 6.35414 6.35326L11.3541 1.35326C11.424 1.2833 11.4716 1.19417 11.4909 1.09716C11.5101 1.00015 11.5002 0.899614 11.4623 0.808262Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/iconExpand.045de87599acad0a3641bdf78e5ca069.svg";
export { ForwardRef as ReactComponent };